export interface remarkInterface {
  nameFR: string;
  nameEN: String;
  nameDE: String;
  avatar: string;
  note: number;
  comFR: string;
  comEN: String;
  comDE: String;
  id: number;
  mouseOn: boolean;
}

export const remark: Array<remarkInterface> = [
  {
    nameFR: 'Alex',
    nameEN: 'Bogdan',
    nameDE: 'Lukas',
    avatar: './assets/images/fakeAvatar/fake1.png',
    note: 5,
    comFR:
      "Des parcours variés, des images comme en vrai, un mode défis interressant, la résistance du home trainer bien synchro à la pente (Comparaison avec des cols que je connais). L’appli m’a permis de passer un confinement sur mon vélo pour des sorties longues « presque comme à l'extérieur ».",
    comEN:
      'Best indoor cycling app, videos are amazing and the platform keeps improving every month. The support is fantastic, the small issues that I reported were solved within a day on average. Love the Hammer Series contest!',
    comDE:
      'Abwechslungsreiche Strecken, realistische Bilder, ein interessanter Herausforderungsmodus, der Widerstand des Heimtrainers passt gut zur Steigung (ich vergleiche mit bekannten Anstiegen). Die App hat mir den Lockdown auf dem Fahrrad fast wie echte Ausfahrten ermöglicht.',
    id: 1,
    mouseOn: false,
  },
  {
    nameFR: 'Patrick',
    nameEN: 'Kazhielle',
    nameDE: 'Johann',
    avatar: './assets/images/fakeAvatar/fake2.png',
    note: 5,
    comFR:
      'Suite à l’achat d’un vélo d’appartement connecté, je recherchais une appli pour m’entraîner et rompre la monotonie du coup de pédale en solitaire. Avec Kinomap, j’ai trouvé mon bonheur. Au menu, des vidéos comme l’ascension du Mont Ventoux ou les Gorges du Verdon.',
    comEN:
      "Your app is really cool and it's really nice to travel the world and discover beautiful sites. New Zealand for example, it's just... wow! Thanks to the whole team and to you who always answer quickly and kindly. You are the best ;-) thanks to you, running becomes a pleasure.",
    comDE:
      'Nach dem Kauf meines vernetzten Heimtrainers suchte ich nach einer App, um mein Training abwechslungsreicher zu gestalten. Mit Kinomap habe ich genau das gefunden. Mit dabei: Videos vom Mont Ventoux oder den Gorges du Verdon!',
    id: 2,
    mouseOn: false,
  },
  {
    nameFR: 'CJ',
    nameEN: 'Jakub',
    nameDE: 'Max',
    avatar: './assets/images/fakeAvatar/fake3.png',
    note: 4,
    comFR:
      'Très bonne application, permettant un entraînement régulier, personnalisé, avec des parcours très variés en termes de durée et de difficulté, permettant aussi de se confronter à soi-même ou à d’autres participants.',
    comEN:
      'I am using the app connected to Domyos T900C and love it. It works great including automatic elevation, if applicable for given trail. It turns indoor running to any trail on the globe.',
    comDE:
      'Sehr gute App für regelmäßiges, personalisiertes Training. Es gibt viele verschiedene Strecken mit unterschiedlicher Dauer und Schwierigkeit. Man kann sich mit sich selbst oder mit anderen messen.',
    id: 3,
    mouseOn: false,
  },
  {
    nameFR: 'Keetoon',
    nameEN: 'Siegfried',
    nameDE: 'Ben',
    avatar: './assets/images/fakeAvatar/fake4.png',
    note: 5,
    comFR:
      "Bonne application. Très grande diversité des parcours. J'aime beaucoup la possibilité de renvoyer la vidéo sur un écran externe pour une meilleure immersion. Fonctionne parfaitement sur mon elliptique Domyos. Stable et mise à jour régulières",
    comEN:
      'Very good videos for every level of difficulty. This app has probably saved my life! Absolutely love it.',
    comDE:
      'Tolle App mit einer riesigen Auswahl an Strecken. Besonders gut gefällt mir, dass man das Video auf einen externen Bildschirm übertragen kann – das sorgt für bessere Immersion. Funktioniert perfekt auf meinem Domyos Crosstrainer. Stabil und regelmäßig aktualisiert.',
    id: 4,
    mouseOn: false,
  },
  {
    nameFR: 'Geronimo',
    nameEN: 'RG',
    nameDE: 'Matthias',
    avatar: './assets/images/fakeAvatar/fake5.png',
    note: 5,
    comFR:
      "Rameur Concept 2 + tapis de course Care marathon 22. Je parcours le monde, je cours dans les rocheuses, je vais ramer à Tahiti et je finis par escalader une montagne enneigée dans l'Utah. Projection écran 4m de base + Apple TV + queen à fond ;) et les séances de coaching !!",
    comEN:
      'My rowing machine is now listed in the app and it works. I’m so happy. At last, it makes inside rowing worth it and now I really enjoy rowing. I have a sportstech machine RSX 600 which is fully equipped with bluetooth and Wifi. Thank you. I already made a payment of 1 year abo',
    comDE:
      'Concept 2 Rudergerät + Care Marathon 22 Laufband. Ich reise um die Welt, laufe in den Rocky Mountains, rudere in Tahiti und beende mit einem verschneiten Berg in Utah. 4-Meter-Leinwand + Apple TV + Queen auf voller Lautstärke ;) und die Coaching-Sessions!!',
    id: 5,
    mouseOn: false,
  },
  {
    nameFR: 'Pascal',
    nameEN: 'Henri',
    nameDE: 'Sebastian',
    avatar: './assets/images/fakeAvatar/fake2.png',
    note: 5,
    comFR:
      'ça permet de voyager de "chez soi" tout en se défoulant. Un grand choix d\'évasion pour tous.',
    comEN:
      'What a nice app! This is a seriously strong fitness app in Combination with an interactive treadmill or Spinning bike. Cycling all over the world and competing with the community!',
    comDE:
      'Man kann von zu Hause aus „verreisen“ und sich dabei richtig auspowern. Eine große Auswahl an Erlebnissen für alle!',
    id: 6,
    mouseOn: false,
  },
  {
    nameFR: 'Alessandro',
    nameEN: 'Pascal',
    nameDE: 'Tobias',
    avatar: './assets/images/fakeAvatar/fake6.jpeg',
    note: 5,
    comFR:
      "Super appli, je me suis mis à faire du sport chez moi pendant le confinement pour éviter une prise de poids et j'ai finalement opté pour cette appli qui donne l'impression d'être à l'extérieur.",
    comEN:
      "Hi. I've been a subscriber for about a year and I recommend this application which, for me, is the best one currently on the market. And if, however, you have a problem, the support is fast and efficient. ",
    comDE:
      'Super App! Ich habe während des Lockdowns angefangen, zu Hause Sport zu treiben, um einer Gewichtszunahme vorzubeugen, und habe mich schließlich für diese App entschieden – sie vermittelt das Gefühl, draußen zu sein.',
    id: 7,
    mouseOn: false,
  },
];
